import clsx from 'clsx';
import styles from './FriendIconShared.module.css';
import { singularOrPlural } from 'utils/common';

export interface FriendIconPlayer {
  avatarUrl?: string;
  name: string;
  status: 'Active' | 'Inactive';
  gracePeriodHoursRemaining: number | null;
}

export type FriendIconIndex = '1' | '2' | '3';

export const isFriendIconInactive = (player: FriendIconPlayer | null) =>
  player?.status === 'Inactive' || player?.gracePeriodHoursRemaining != null;

export const getFriendIconTailPosition = (index: FriendIconIndex) => {
  // TODO we probably don't need this function anymore, as all speech bubbles
  // come from the bottom
  switch (index) {
    case '1':
      return 'left-bottom' as const;
    case '2':
      return 'left-bottom' as const;
    case '3':
    default:
      return 'left-bottom' as const;
  }
};

const NON_BREAKING_SPACE = '\u00A0';

export const FriendIconBubbleContent = ({
  player,
  hideStatus,
  hackSmallerFont,
}: {
  player: FriendIconPlayer | null;
  hideStatus?: boolean;
  /** The font size is too big on the cancellation flow. Bodge it to be smaller */
  hackSmallerFont?: boolean;
}) => {
  if (!player) {
    // Render missing players as a non-breaking space, so that the div has some height and width to it
    return (
      <div className={clsx(styles.empty)}>
        <p className={styles.bubbleContent}>{NON_BREAKING_SPACE}</p>
        <p className={clsx(styles.bubbleContent, 'aboutUsTypographyCaption')}>
          {NON_BREAKING_SPACE}
        </p>
      </div>
    );
  }

  let statusText: string;
  let statusClassName: string;
  if (player?.gracePeriodHoursRemaining != null) {
    if (player.gracePeriodHoursRemaining <= 1) {
      statusText = 'Leaving';
    } else {
      statusText = `Leaving ${player.gracePeriodHoursRemaining}${singularOrPlural(player.gracePeriodHoursRemaining, 'hr', 'hrs')}`;
    }
    statusClassName = styles.playerStatusLeaving;
  } else if (isFriendIconInactive(player)) {
    statusText = player.status;
    statusClassName = styles.playerStatusInactive;
  } else {
    statusText = player.status;
    statusClassName = styles.playerStatusActive;
  }

  return (
    <>
      <p
        className={clsx(
          styles.bubbleContent,
          hackSmallerFont && styles.hackSmallerFont,
        )}
        title={player.name}
      >
        <strong>{player.name}</strong>
      </p>
      {!hideStatus && (
        <p
          className={clsx(
            styles.bubbleContent,
            'aboutUsTypographyCaption',
            statusClassName,
          )}
        >
          {statusText}
        </p>
      )}
    </>
  );
};
